// assets
import CarOutlined from '@ant-design/icons/CarOutlined';

const icons = { CarOutlined };

// ==============================|| MENU ITEMS - CARRIERS ||============================== //

const carriers = {
  id: 'carriers',
  title: 'Carriers',
  type: 'group',
  url: '/carriers',
  icon: icons.CarOutlined,
  permission: {
    module: 'carriers',
    level: 10 // View permission required
  }
};

export default carriers;
